<app-menu [hasChanges]="loadMenu" title="Registro de Gastos"></app-menu>
<app-loading [show]="load"></app-loading>
<div class="min-h-screen bg-white">

    <p-stepper [value]="1">
        <p-step-item [value]="1">
            <p-step>Registro de gastos</p-step>
            <p-step-panel>
                <ng-template #content let-activateCallback="activateCallback">
                    <form [formGroup]="formRegistro">
                        <div class="flex flex-wrap">
                            <div class="w-full md:w-4 flex flex-column p-2">
                                <label class="pb-2">Tipo de Gasto</label>
                                <p-select [options]="typeExpenses" formControlName="tipoGasto" optionLabel="description"
                                    placeholder="Seleccione un tipo de gasto" class="w-full" />
                            </div>
                            <div class="w-full md:w-4 flex flex-column p-2">
                                <label class="pb-2">Concepto</label>
                                <input type="text" class="p-inputtext" pInputText
                                    placeholder="Relacione el concepto del gasto a registrar"
                                    formControlName="descripcion" pAutoFocus [autofocus]="true">
                                <span class="text-xs text-right">{{100-formRegistro.controls.descripcion.value!.length}}
                                    carácteres</span>
                            </div>
                            <div class="w-full md:w-4 flex flex-column p-2">
                                <label class="pb-2">Valor</label>
                                <p-inputNumber placeholder="Relacione el valor" mode="currency" currency="USD"
                                    locale="en-US" [minFractionDigits]="0" class="w-full"
                                    formControlName="valor"></p-inputNumber>
                            </div>
                            <div class="w-full text-center">
                                <button pButton class="p-button p-button-success" label="Aceptar" (click)="setGasto()"
                                    icon="pi pi-check-circle" #btnRegister
                                    *ngIf="btnShow && (valorMaxPermitido >= (formRegistro.controls['valor'].value ??0))"></button>
                                <span [innerHTML]="msgText"></span>
                            </div>
                        </div>
                    </form>
                </ng-template>
            </p-step-panel>
        </p-step-item>

        <p-step-item [value]="2">
            <p-step>Consulta de gastos registrados</p-step>
            <p-step-panel>
                <ng-template #content let-activateCallback="activateCallback">
                    <div class="m-3" class="relative h-screen">
                        <div class="text-center w-full md:w-3 mx-auto ">
                            <div class="flex flex-column">
                                <label class="pb-2">Seleccione la fecha de consulta</label>
                                <div class="flex gap-1 w-full justify-content-center">
                                    <p-datepicker [(ngModel)]="dateQuery" size="small"
                                        dateFormat="yy-mm-dd"></p-datepicker>
                                    <button pButton icon="pi pi-search" class="p-button p-button-success mt-1"
                                        (click)="getInfoGastos()"></button>
                                </div>
                            </div>

                        </div>
                        <div class="w-full border-top-2 border-200 mt-2" id="gastos">
                            <div class="hidden md:flex flex-wrap" *ngIf="infoGastos.length > 0">
                                <div class="w-4 text-center">
                                    <h4>Hora</h4>
                                </div>
                                <div class="w-4 text-center">
                                    <h4>Descripción</h4>
                                </div>
                                <div class="w-4 text-center">
                                    <h4>Valor ($)</h4>
                                </div>
                            </div>
                            <div class="flex flex-wrap pt-3 border-top-2 border-200" id="divGasto{{index+1}}"
                                *ngFor="let row of infoGastos; let index=index">
                                <div class="w-4 text-center">{{row.fecha |
                                    date:'shortTime'}}
                                    -&nbsp;{{row.observacion}}</div>
                                <div class="w-4 text-center">{{row.observacion}}</div>
                                <div class="w-4 text-center"><span class="p-d-md-none">Valor:</span> &nbsp;{{row.valor |
                                    currency}}<button pButton icon="pi pi-print" class="p-button p-button-link"
                                        (click)="printDiv('divGasto','Gasto',index+1)"></button></div>
                                <div class="w-full">
                                    <hr>
                                </div>
                            </div>
                            <div class="flex" *ngIf="infoGastos.length > 0">
                                <div class="w-6 text-center">
                                    <h4>Total gastos</h4>
                                </div>
                                <div class="w-6 text-center">
                                    <h4>{{totalGastosAnt | currency}}</h4>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="infoGastos.length > 0" class="text-center"><button pButton
                                class="p-button p-button-success" label="Imprimir" icon="pi pi-print"
                                (click)="printDiv('gastos','Información de gastos')"></button></div>
                    </div>
                </ng-template>
            </p-step-panel>
        </p-step-item>

    </p-stepper>

</div>
<p-toast></p-toast>
<app-footer></app-footer>